import Vue from 'vue'
import vSelect from 'vue-select'

// Load themed vue-select styles once globally. Per-route @imports were
// code-split into component CSS chunks and could unload, leaving gray badges.
import '@core/scss/vue/libs/vue-select.scss'

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
  Deselect: {
    render: h => h('feather-icon', { props: { size: '14', icon: 'XIcon' } }),
  },
  OpenIndicator: {
    render: h => h('feather-icon', { props: { size: '15', icon: 'ChevronDownIcon' }, class: 'open-indicator' }),
  },
})

Vue.component(vSelect)
